import {
  mapArrayField,
  mapDateField,
  mapObjectField,
} from "~/v2/mappers/vaas-helpers"
import type {
  VaasCaption,
  VaasLesson,
  VaasVersionSummary,
} from "~/v2/types/vaas"

const mapCaption = (caption: any): VaasCaption => ({
  ...caption,
  id: caption?.id ?? null,
})

const mapVersionSummary = (version: any): VaasVersionSummary => ({
  ...version,
  id: version?.id ?? null,
  version: version?.version ?? null,
  updated: mapDateField(version?.updated),
})

const mapVaasLesson = (lesson: any): VaasLesson | null => {
  if (!lesson) {
    return null
  }

  return {
    ...lesson,
    captions: mapArrayField(lesson.captions).map(mapCaption),
    created: mapDateField(lesson.created),
    description: lesson.description === null ? "" : lesson.description,
    duration:
      lesson.duration === null || lesson.duration === undefined
        ? null
        : Math.floor(Number(lesson.duration)),
    thumbnail: mapObjectField(lesson.thumbnail),
    updated: mapDateField(lesson.updated),
    video: lesson.video ? { ...lesson.video } : null,
    versions: mapArrayField(lesson.versions).map(mapVersionSummary),
  }
}

const mapVaasLessonList = (lessons: unknown): VaasLesson[] =>
  mapArrayField(lessons).map(mapVaasLesson).filter(Boolean) as VaasLesson[]

export { mapVaasLesson, mapVaasLessonList }
